import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-violet text-cream/70 py-8 px-4 text-center text-sm border-t-4 border-gold" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <p className="font-rounded font-bold text-cream mb-2 text-base" data-id="element-79">
          Biblioteca Mágica © 2026 · Todos los derechos reservados
        </p>
        <p className="max-w-2xl mx-auto text-xs opacity-80 font-semibold leading-relaxed" data-id="element-80">
          Este es un producto digital. No se enviará ningún producto físico a su
          domicilio. Debido a la naturaleza digital del producto y su acceso
          inmediato, no se ofrecen reembolsos una vez realizada la descarga.
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
};